import { render, staticRenderFns } from "./AddToCartFeature.vue?vue&type=template&id=00b85153&"
import script from "./AddToCartFeature.vue?vue&type=script&lang=ts&"
export * from "./AddToCartFeature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddToCartFeature.vue"
export default component.exports